import Button from 'components/Button';
import Trash from 'icons/Trash';
import { Photo, usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryCartItems.module.scss';
import { useUser } from 'stores/userStore';
import Image from 'components/Image';

export const TRANSACTION_FEE_IN_CENTS = 199;
export const DISCOUNT_MULTIPLIER = 0.9;
const dollarFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format;

export default function PhotoGalleryCartItems() {
  const [{ photoGallery, selectedPhotos, photoSlides }, { setSelectedPhotos }] = usePhotoGalleryContainer();
  const { isLoggedIn } = useUser();

  const handleDelete = (photoIndex: number, photoResolution: string) => {
    setSelectedPhotos(currentPhotos =>
      currentPhotos.filter(photo => !(photo.index === photoIndex && photo.resolution === photoResolution))
    );
  };

  const buildDisplayPrice = (photo: { displayPrice: string; price: number }) => {
    const discounted = dollarFormatter(Math.round(photo.price * DISCOUNT_MULTIPLIER) / 100);
    return isLoggedIn ? (
      <div className={`${styles.LineItemPrice} ${styles.LineItemPriceDiscounted}`}>
        <span className={styles.strikethrough}>{photo.displayPrice}</span>
        <span className={styles.discounted}>{discounted}</span>
      </div>
    ) : (
      <div className={styles.LineItemPrice}>{photo.displayPrice}</div>
    );
  };

  return (
    <>
      <div className={styles.CartItemsContainer}>
        {selectedPhotos.map(photo => {
          const photoDetails = photoSlides[photo.index] as Photo;
          const res = photo.isHighResolution ? 'high' : 'low';
          const key = `${photoDetails.id}-${res}`;
          return (
            <div className={styles.LineItem} key={key}>
              <Image className={styles.LineItemThumbnail} src={photoDetails.s3Watermark ?? photoDetails.watermark} />
              <div className={styles.LineItemInfo}>
                <div className={styles.LineItemName}>{photoDetails.filename}</div>
                <div className={styles.LineItemResolution}>{photo.resolution}</div>
                {buildDisplayPrice(photo)}
              </div>
              <div className={styles.CartItemDeleteContainer}>
                <Button
                  label={<Trash />}
                  type="white"
                  className={styles.CartItemDelete}
                  onClick={() => handleDelete(photo.index, photo.resolution)}
                />
              </div>
            </div>
          );
        })}
      </div>
      {selectedPhotos.length ? (
        <div className={styles.TransactionFee}>Transaction fee: {dollarFormatter(TRANSACTION_FEE_IN_CENTS / 100)}</div>
      ) : null}
    </>
  );
}
